import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    standalone: false
})
export class SpinnerComponent implements OnInit {
  @Input() size: number = 25;
  @Input() show: boolean;
  spinnerSrc = 'assets/Images/spinner.gif';
  constructor() { }

  ngOnInit(): void {
  }

}
